/**
 * Bật lại đăng ký công khai (/register + link trên trang login) khi cần.
 * Mặc định tắt — tài khoản do admin tạo.
 */
export const ENABLE_PUBLIC_REGISTRATION = false;
